import { CulturalOutingInput } from '../../lib/types/models/cultural-outing/cultural-outing-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateCulturalOuting(
  input: UpdateInput<CulturalOutingInput & { coachCompanyId?: number }>
) {
  const { id, ...data } = input
  return restApiClient.url(constructApiUrl(API.culturalOutings.update.url, { id })).patch(data)
}
